export default __webpack_public_path__ + "static/media/need_jobs.20e66047.png";